import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const rem = (px: number) => `${Math.round(px / 16)}rem`;

export function getAssetsUrl(name: string) {
  return `https://static.backpac.app/assets/${name}`;
}

export function getStaticResourceUrl(name: string) {
  return `https://static.backpac.app/${name}`;
}
